module.exports = __webpack_public_path__ + "img/errorbg.12bcff8b.jpg";